import { Card, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useEffect } from "react";
import cross from "../assets/img/cross.svg";
import { updateSeasonalBadge } from "store/actions/SeasonActions";
import { toast } from "react-toastify";
import { isManagerExist } from "store/actions/SeasonActions";
import SeasonalPreview from "./SeasonalPreview";
import VideoIcon from "../assets/img/custom/VIDEO_VIEW_ICON.png";
import { getNext5Years } from "context";
import { getSeasonalBadges } from "store/actions/SeasonActions";

const SeasonalEditModal = ({ toggle, editModal, updateObj }) => {
  const dispatch = useDispatch();
  const { uid, user } = useSelector((state) => state.auth);
  const [removedImg, setRemovedImg] = useState("");
  const [showCustomPriceInput, setShowCustomPriceInput] = useState(false);
  const [showCustomPriceInput2, setShowCustomPriceInput2] = useState(false);
  const [managerEmail, setManagerEmail] = useState("");
  const [videoURL, setvideoURL] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [onlineUrlPrice, setonlineUrlPrice] = useState("");
  const [qrCode, setqrCode] = useState("");
  const [qrCodePrice, setqrCodePrice] = useState("");
  const [eventPlus, setEventPlus] = useState("");
  const [badgeData, setBadgeData] = useState({
    type: "",
    year: "",
    sport: "",
    listNumber: "",
    typeData1: "",
    typeData2: "",
    typeData3: "",
    sportType: "",
    created_at: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const isBadgeDataValid = Object.keys(badgeData)
      .filter((key) => key !== "type")
      .every((key) => badgeData[key] !== "");

    if (isBadgeDataValid && (isVideoUrlPairFilled || isQrCodePairFilled)) {
      const payload = {
        athleteID: user?.athleteID,
        athlete_id: uid,
        isDeleted: false,
        ...badgeData,
        managerEmail,
        bought: updateObj?.bought,
        ...(isVideoUrlPairFilled && { videoURL, onlineUrlPrice }),
        ...(isQrCodePairFilled && { qrCode, qrCodePrice }),
        ...(eventPlus && { eventPlus }),
        ...(updateObj?.extra_badge_pay && {
          amount: updateObj.amount,
          extra_badge_pay: updateObj.extra_badge_pay,
        }),
      };
      if (
        (isVideoUrlPairFilled && onlineUrlPrice === 0) ||
        (isQrCodePairFilled && qrCodePrice === 0)
      ) {
        return toast.warning("add amount");
      } else if (managerEmail === "") {
        setIsLoading(true);
        dispatch(
          updateSeasonalBadge(updateObj?.id, payload, removedImg, () => {
            setIsLoading(false);
            toggle();
            dispatch(getSeasonalBadges(user?.athleteID, "", () => {}));
            setBadgeData({
              type: "",
              year: "",
              sport: "",
              listNumber: "",
              typeData1: "",
              typeData2: "",
              typeData3: "",
            });
            setRemovedImg("");
            setManagerEmail("");
            setvideoURL("");
            setonlineUrlPrice("");
            setqrCode("");
            setqrCodePrice("");
          })
        );
      } else {
        setIsLoading(true);
        dispatch(
          isManagerExist(managerEmail, () => {
            dispatch(
              updateSeasonalBadge(updateObj?.id, payload, removedImg, () => {
                setIsLoading(false);
                toggle();
                dispatch(getSeasonalBadges(user?.athleteID, "", () => {}));
                setBadgeData({
                  type: "",
                  year: "",
                  sport: "",
                  listNumber: "",
                  typeData1: "",
                  typeData2: "",
                  typeData3: "",
                });
                setRemovedImg("");
                setManagerEmail("");
                setvideoURL("");
                setonlineUrlPrice("");
                setqrCode("");
                setqrCodePrice("");
              })
            );
          })
        );
      }
    } else {
      toast.error("Invalid badgeData: Some Fields are empty.");
    }
  };

  const isVideoUrlPairFilled = videoURL !== "" && onlineUrlPrice !== "";
  const isQrCodePairFilled = qrCode !== "" && qrCodePrice !== "";

  const data = {
    year: badgeData.year,
    sport: badgeData.sport,
    type: badgeData.type,
    eventPlus: eventPlus,
    sportType: badgeData.sportType,
    listNumber: badgeData.listNumber,
    typeData1: badgeData.typeData1,
    typeData2: badgeData.typeData2,
    typeData3: badgeData.typeData3,
    qrPrice: qrCodePrice,
    qrCodeImage: qrCode,
  };

  useEffect(() => {
    if (updateObj) {
      setBadgeData({
        type: updateObj.type,
        year: updateObj?.year,
        sport: updateObj?.sport,
        listNumber: updateObj?.listNumber,
        typeData1: updateObj?.typeData1,
        typeData2: updateObj?.typeData2,
        typeData3: updateObj?.typeData3,
        sportType: updateObj?.sportType,
        created_at: updateObj?.created_at,
      });
      setManagerEmail(updateObj?.managerEmail || "");
      setEventPlus(updateObj?.eventPlus || "");
      setvideoURL(updateObj?.videoURL || "");
      setonlineUrlPrice(updateObj?.onlineUrlPrice || "");
      setqrCode(updateObj?.qrCode || "");
      setqrCodePrice(updateObj?.qrCodePrice || "");
      setShowCustomPriceInput2(false);
      setShowCustomPriceInput(false);
    }
  }, [updateObj]);

  return (
    <Modal isOpen={editModal} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Update seasonal Badge</ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <Row className="d-flex justify-content-center">
            <Col className="col-4">
              <FormGroup>
                <Label for="exampleSelect">Season Place</Label>
                <Input
                  id="exampleSelect"
                  name="select"
                  type="select"
                  value={badgeData?.type}
                  required
                  onChange={(e) =>
                    setBadgeData({ ...badgeData, type: e.target.value })
                  }
                >
                  <option value="">--Select Type--</option>
                  <option value="Pre-season">Pre-season </option>
                  <option value="Post-season">Post-season </option>
                  <option value="Pre-event">Pre-event</option>
                  <option value="Post-event">Post-event</option>
                  <option value="X">X</option>
                </Input>
              </FormGroup>
            </Col>
            {(badgeData.type == "Pre-event" ||
              badgeData.type == "Post-event" ||
              badgeData.type == "X") && (
              <Col className="col-4">
                <FormGroup>
                  <Label for="exampleEvent">Event plus</Label>
                  <Input
                    id="exampleEvent"
                    name="select"
                    type="select"
                    value={eventPlus}
                    required
                    onChange={(e) => setEventPlus(e.target.value)}
                  >
                    <option value="">--Select Event--</option>
                    {badgeData.type == "X"
                      ? Array.from({ length: 50 }, (_, index) => (
                          <option
                            key={index + 1}
                            value={`X ${String(index + 1).padStart(2, "0")}`}
                          >
                            X {String(index + 1).padStart(2, "0")}
                          </option>
                        ))
                      : Array.from({ length: 120 }, (_, index) => (
                          <option key={index + 1} value={String(index + 1)}>
                            {index + 1}
                          </option>
                        ))}
                  </Input>
                </FormGroup>
              </Col>
            )}
            <Col className="col-4">
              <FormGroup>
                <Label for="exampleSelect">Season</Label>
                <Input
                  id="exampleSelect"
                  required
                  name="select"
                  type="select"
                  value={badgeData?.year}
                  onChange={(e) =>
                    setBadgeData({ ...badgeData, year: e.target.value })
                  }
                >
                  <option value="">--Select Season--</option>
                  {getNext5Years().map((year) => (
                    <option key={year}>{year}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="exampleSelect">Sport</Label>
                <Input
                  required
                  id="exampleSelect"
                  name="select"
                  type="select"
                  value={badgeData?.sport}
                  onChange={(e) =>
                    setBadgeData({ ...badgeData, sport: e.target.value })
                  }
                >
                  <option value="">--Select Sport--</option>
                  <option value="FOOTBALL">FOOTBALL</option>
                  <option value="BASKETBALL">BASKETBALL</option>
                  <option value="SOCCER">SOCCER</option>
                  <option value="VOLLEYBALL">VOLLEYBALL</option>
                  <option value="TRACK AND FIELD">TRACK AND FIELD</option>
                  <option value="CROSS COUNTRY">CROSS COUNTRY</option>
                  <option value="BASEBALL">BASEBALL</option>
                  <option value="TENNIS">TENNIS</option>
                  <option value="WRESTLING">WRESTLING</option>
                  <option value="SOFTBALL">SOFTBALL</option>
                  <option value="SWIMMING & DIVING">SWIMMING & DIVING</option>
                  <option value="GOLF">GOLF</option>
                  <option value="COMPETITIVE CHEER/SPIRIT">COMPETITIVE CHEER/SPIRIT</option>
                  <option value="LACROSSE">LACROSSE</option>
                  <option value="FLAG FOOTBALL">FLAG FOOTBALL</option>
                  <option value="BOWLING">BOWLING</option>
                  <option value="FIELD HOCKEY">FIELD HOCKEY</option>
                  <option value="WATER POLO">WATER POLO</option>
                  <option value="ICE HOCKEY">ICE HOCKEY</option>
                  <option value="WEIGHTLIFTING">WEIGHTLIFTING</option>
                  <option value="GYMNASTICS">GYMNASTICS</option>
                  <option value="BEACH VOLLEYBALL">BEACH VOLLEYBALL</option>
                  <option value="SKIING / ALPINE SKIING">SKIING / ALPINE SKIING</option>
                  <option value="BADMINTON">BADMINTON</option>
                  <option value="ESPORTS">ESPORTS</option>
                  <option value="RUGBY">RUGBY</option>
                  <option value="ARCHERY">ARCHERY</option>
                  <option value="FISHING">FISHING</option>
                  <option value="FENCING">FENCING</option>
                  <option value="OTHER">OTHER</option>
                </Input>
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="exampleCategory">Select Event Category</Label>
                <Input
                  required
                  id="exampleCategory"
                  name="select"
                  type="select"
                  value={badgeData?.sportType}
                  onChange={(e) =>
                    setBadgeData({ ...badgeData, sportType: e.target.value })
                  }
                >
                  <option value="">--Select Category--</option>
                  <option value="game">Game</option>
                  <option value="meet">Meet</option>
                  <option value="match">Match</option>
                  <option value="cmpet">Cmpet</option>
                  <option value="tourn">Tourn</option>
                </Input>
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="exampleSelect">Number</Label>
                <Input
                  required
                  id="exampleSelect"
                  name="select"
                  type="select"
                  value={badgeData?.listNumber}
                  onChange={(e) =>
                    setBadgeData({ ...badgeData, listNumber: e.target.value })
                  }
                >
                  <option key={1200} value="">
                    --Select Number--
                  </option>
                  {Array.from({ length: 60 }).map((_, index) => (
                    <option key={index + 400} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>

            <Col className="col-4">
              <FormGroup>
                <Label for="exampleManager">Add manager Email</Label>
                <Input
                  id="exampleManager"
                  name="select"
                  type="text"
                  placeholder="Add manager Email"
                  value={managerEmail}
                  onChange={(e) => setManagerEmail(e.target.value)}
                ></Input>
              </FormGroup>
            </Col>
            <Col className="col-4 seasonal-text">
              <FormGroup>
                <Label for="exampleType">Vertical text</Label>
                <Input
                  required
                  id="exampleType"
                  name="select"
                  type="text"
                  placeholder="Vertical text"
                  value={badgeData?.typeData1}
                  onChange={(e) =>
                    setBadgeData({ ...badgeData, typeData1: e.target.value })
                  }
                ></Input>
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="exampleType">Horizontal text</Label>
                <Input
                  required
                  id="exampleType"
                  name="select"
                  type="text"
                  placeholder="Horizontal text"
                  value={badgeData?.typeData2}
                  onChange={(e) =>
                    setBadgeData({ ...badgeData, typeData2: e.target.value })
                  }
                ></Input>
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="exampleType">Horizontal two text</Label>
                <Input
                  required
                  id="exampleType"
                  name="select"
                  type="text"
                  placeholder="Horizontal text"
                  value={badgeData?.typeData3}
                  onChange={(e) =>
                    setBadgeData({ ...badgeData, typeData3: e.target.value })
                  }
                ></Input>
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="exampleSelect">Online Video URL</Label>
                <Input
                  id="exampleSelect"
                  name="select"
                  type="text"
                  placeholder="Video URL"
                  value={videoURL}
                  onChange={(e) => setvideoURL(e.target.value)}
                ></Input>
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="exampleSelect">Online Video View Price</Label>
                <Input
                  id="exampleSelect"
                  name="select"
                  type="select"
                  value={onlineUrlPrice}
                  onChange={(e) => {
                    setonlineUrlPrice(Number(e.target.value));
                    if (e.target.value === "custom") {
                      setShowCustomPriceInput2(true);
                    } else {
                      setShowCustomPriceInput2(false);
                    }
                  }}
                >
                  <option value="">--Select Price--</option>
                  <option value="6">6</option>
                  <option value="8">8</option>
                  <option value="10">10</option>
                  {/* {onlineUrlPrice && (
                    <option value={onlineUrlPrice}>{onlineUrlPrice}</option>
                  )} */}
                  <option value="custom">Custom Value</option>
                </Input>
                {showCustomPriceInput2 && (
                  <Input
                    className="mt-2"
                    type="number"
                    placeholder="Enter Custom Value"
                    value={onlineUrlPrice}
                    onChange={(e) => setonlineUrlPrice(Number(e.target.value))}
                    min={11}
                    max={500}
                  />
                )}
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup className="d-flex flex-column">
                <Label for="exampleSelect">QR Code</Label>
                {qrCode && (
                  <div className="position-relative">
                    <img
                      src={
                        qrCode instanceof File
                          ? URL.createObjectURL(qrCode)
                          : qrCode
                      }
                      alt=""
                      className="mb-3"
                      width={80}
                      height={80}
                    />
                    <img
                      src={cross}
                      width={20}
                      alt=""
                      className="position-absolute"
                      style={{
                        top: "-11%",
                        left: "39%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setRemovedImg(qrCode);
                        setqrCode("");
                      }}
                    />
                  </div>
                )}
                {!qrCode && (
                  <Input
                    id="exampleSelect"
                    name="select"
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setqrCode(file);
                      }
                    }}
                  ></Input>
                )}
              </FormGroup>{" "}
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="exampleSelect">Online Badge Card Price</Label>
                <Input
                  id="exampleSelect"
                  name="select"
                  type="select"
                  value={qrCodePrice}
                  onChange={(e) => {
                    setqrCodePrice(Number(e.target.value));
                    if (e.target.value === "custom") {
                      setShowCustomPriceInput(true);
                    } else {
                      setShowCustomPriceInput(false);
                    }
                  }}
                >
                  <option value="">{qrCodePrice}</option>
                  <option value="8">8</option>
                  <option value="16">16</option>
                  <option value="32">32</option>
                  {/* {qrCodePrice && (
                    <option value={qrCodePrice}>{qrCodePrice}</option>
                  )} */}
                  <option value="custom">Custom Value</option>
                </Input>
                {showCustomPriceInput && (
                  <Input
                    className="mt-2"
                    type="number"
                    placeholder="Enter Custom Value"
                    value={qrCodePrice}
                    onChange={(e) => setqrCodePrice(Number(e.target.value))}
                    min={17}
                    max={1000}
                  />
                )}
              </FormGroup>{" "}
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Button color="primary" type="submit">
              {isLoading ? (
                <Spinner size="sm" className="mx-4" />
              ) : (
                "Update Badge"
              )}
            </Button>
          </Row>
        </Form>
        <Row className="d-flex justify-content-center">
          <Card className="col-lg-6 col-md-8 col-sm-8 mb-3 mt-5 mx-2">
            <SeasonalPreview data={data} />
          </Card>
          <Card className="col-lg-4 sol-md-12 sol-sm-8 mb-3 mt-5 mx-2 text-center">
            <h4 className="m-0 p-0">
              {badgeData?.type === "X"
                ? eventPlus?.substring(0, 4)
                : badgeData?.type?.substring(0, 4)}{" "}
              {badgeData.sportType} {badgeData.listNumber}
            </h4>
            <a className="text-white  " href={videoURL} target="_blank">
              <img src={VideoIcon} className="image-flui" />
            </a>
            <h4 className="mb-0">
              {user?.first_name + " " + user?.last_name} {user.athleteID}
              <h4>{badgeData.sport}</h4>
            </h4>{" "}
            <h3 className="m-0 p-0">{onlineUrlPrice}</h3>
          </Card>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default SeasonalEditModal;
